import { tv } from 'tailwind-variants'

export const buttonVariants = tv({
  base: 'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-surface-950 disabled:pointer-events-none disabled:opacity-50',
  variants: {
    variant: {
      primary: 'bg-primary-600 text-white hover:bg-primary-500 active:bg-primary-700',
      secondary:
        'border border-white/15 bg-white/5 text-slate-100 hover:bg-white/10 active:bg-white/[0.12]',
      ghost: 'text-slate-200 hover:bg-white/10',
      destructive: 'bg-danger-600 text-white hover:bg-danger-500',
      outline: 'border border-white/20 bg-transparent hover:bg-white/5',
    },
    size: {
      sm: 'h-8 px-3 text-xs',
      md: 'h-10 px-4 text-sm',
      lg: 'h-12 px-6 text-base',
      icon: 'h-10 w-10 p-0',
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
  },
})
